import { AxiosRequest } from "./axios-request"
import { GET_ENUMS, GET_STATE_LIST } from "./constant"


const GetStateList = () => {
    return AxiosRequest.get(GET_STATE_LIST)
}

const GetEnums = () => {
    return AxiosRequest.get(GET_ENUMS)
}

export { GetStateList, GetEnums }